import postQuestionnairesData from "./formData/postQuestionnairesData";
import preSleepInfoData from "./formData/preSleepInfoData";

export const POST_SLEEP_FORM_NAME = "แบบสอบถามหลังการตรวจการนอนหลับ";
export const PRE_SLEEP_FORM_NAME = "แบบซักประวัติก่อนตรวจการนอน";

const sleepScheduleFormDefinitions = {
  [POST_SLEEP_FORM_NAME]: {
    id: 2,
    formId: "F-02",
    info: postQuestionnairesData,
  },
  [PRE_SLEEP_FORM_NAME]: {
    id: 3,
    formId: "F-03",
    info: preSleepInfoData,
  },
};

const getPatientNamePart = (patient, thaiField, fallbackField) =>
  (patient && (patient[thaiField] || patient[fallbackField])) || "";

export const getPatientDisplayName = (patient) =>
  `${getPatientNamePart(patient, "firstnameTh", "firstname")} ${getPatientNamePart(
    patient,
    "lastnameTh",
    "lastname",
  )}`.trim();

const buildPatientAppFormLink = (path, uuid, hn) => {
  if (!path || !uuid || !hn) return "";

  const formPath = `${path}/${encodeURIComponent(hn)}/${encodeURIComponent(uuid)}`;
  return typeof window === "undefined"
    ? formPath
    : `${window.location.origin}${formPath}`;
};

export const buildPatientFormLink = (
  formName,
  uuid,
  patient,
  submitted = false,
) => {
  if (!uuid) return "";

  const hn = (patient && patient.hn) || "";
  const firstName = getPatientNamePart(patient, "firstnameTh", "firstname");
  const lastName = getPatientNamePart(patient, "lastnameTh", "lastname");

  if (submitted && formName === PRE_SLEEP_FORM_NAME) {
    return buildPatientAppFormLink("/preSleepInformation", uuid, hn);
  }

  if (submitted && formName === POST_SLEEP_FORM_NAME) {
    return buildPatientAppFormLink("/postQuestionnaires", uuid, hn);
  }

  if (formName === "ข้อมูลพื้นฐาน") {
    return `https://docs.google.com/forms/d/e/1FAIpQLScySG_4518UmzD3iayPZfYtZNYvasprjAovOJqJrec5tq7GVA/viewform?usp=pp_url&entry.838754873=${encodeURIComponent(
      uuid,
    )}&entry.609079995=${encodeURIComponent(
      hn,
    )}&entry.817972638=${encodeURIComponent(
      firstName,
    )}&entry.2138131198=${encodeURIComponent(lastName)}`;
  }

  if (formName === PRE_SLEEP_FORM_NAME) {
    return `https://docs.google.com/forms/d/e/1FAIpQLSctvkv5dh22HFMk-F1H61_iQvxziWenAK0M8IaapqKnB2DRzA/viewform?usp=pp_url&entry.838754873=${encodeURIComponent(
      uuid,
    )}&entry.609079995=${encodeURIComponent(
      hn,
    )}&entry.817972638=${encodeURIComponent(
      firstName,
    )}&entry.2138131198=${encodeURIComponent(lastName)}`;
  }

  if (formName === "แบบฟอร์มการติดตามผลการใช้เครื่องอัดอากาศแรงดันบวก") {
    return `https://docs.google.com/forms/d/e/1FAIpQLScUE2YAXoX8WzKmPvxNmfy1F-aXzHnBybL6oHvyydCpBW0lAQ/viewform?usp=pp_url&entry.1686916653=${encodeURIComponent(
      uuid,
    )}&entry.1366735728=${encodeURIComponent(
      hn,
    )}&entry.614561988=${encodeURIComponent(
      firstName,
    )}&entry.1635974890=${encodeURIComponent(lastName)}`;
  }

  return `https://docs.google.com/forms/d/e/1FAIpQLSdfCWwuW9YqvyYili4YRR-MorC4yW-acSlComd72JACO6iwlw/viewform?usp=pp_url&entry.838754873=${encodeURIComponent(
    uuid,
  )}&entry.609079995=${encodeURIComponent(
    hn,
  )}&entry.817972638=${encodeURIComponent(
    firstName,
  )}&entry.2138131198=${encodeURIComponent(lastName)}`;
};

export const createSleepScheduleFormRecord = (formName, uuid, createdBy) => {
  const definition = sleepScheduleFormDefinitions[formName];

  if (!definition) {
    throw new Error("Unsupported sleep study questionnaire");
  }

  const now = new Date();
  now.setHours(now.getHours() + 7);
  const timestamp = now.toISOString();

  return {
    id: String(definition.id),
    formId: definition.formId,
    formname: formName,
    assign: true,
    submit: false,
    info: JSON.parse(JSON.stringify(definition.info)),
    uuid,
    createAt: timestamp,
    updateAt: timestamp,
    createBy: createdBy || "",
  };
};
